export default __webpack_public_path__ + "static/media/green.e5bd7bd5.webp";